import script from "./MatriculasAnualPie.vue?vue&type=script&setup=true&lang=js"
export * from "./MatriculasAnualPie.vue?vue&type=script&setup=true&lang=js"

import "./MatriculasAnualPie.vue?vue&type=style&index=0&id=eaf8cfe0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaf8cfe0"]])

export default __exports__